import { getAxiosInstance } from '../blocks/axios/axiosFactory';
import { GetTicketTransactionsRequest } from '../models/ticket/GetTicketTransactionsRequest';

const url = "/ticket";

export default class TicketService {
    static getTicketTransactions(request: GetTicketTransactionsRequest) {
        return getAxiosInstance().get(`${url}/ticketTransactions`, { params: { ...request } });
    }

    static getLatestTicketTransactions() {
        const request = { pageNumber: 1, pageSize: 10 } as GetTicketTransactionsRequest;
        return getAxiosInstance().get(`${url}/ticketTransactions`, { params: { ...request } });
    }
}
